import { Checkbox, FormControlLabel, Grid, MenuItem, makeStyles } from '@material-ui/core';
import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import { isStrictEquals } from '../../utils/general/general-utils';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXSelectClienteAutocomplete from '../../shared-components/final-select-cliente-field/QCXSelectClienteAutocomplete';
import QCXTextField from '../../shared-components/text-field/QCXTextField';
import QCXSelectPortoAeroportoAutocomplete from '../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoAutocomplete';
import QCXSelectIncotermCondicaoVendaAutocomplete from '../../shared-components/final-select-incoterm-condicao-venda-field/QCXSelectIncotermCondicaoVendaAutocomplete';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import QCXFinalBondManagerOld from '../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManagerOld';
import QCXSelectServicoAutocomplete from '../../shared-components/select-servico/QCXSelectServicoAutocomplete';
import QCXSelectTabelaFreteAutocomplete from '../../shared-components/final-select-tabela-frete-field/QCXSelectTabelaFreteAutocomplete';
import QCXSelectPortoAeroportoLocalOrigemAutocomplete from '../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoLocalOrigemAutocomplete';
import QCXSelectPortoAeroportoLocalDestinoAutocomplete from '../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoLocalDestinoAutocomplete';
import QCXSelectPortoAeroportoLocalAeroportoAutocomplete from '../../shared-components/select-porto-aeroporto/QCXSelectPortoAeroportoLocalAeroportoAutocomplete';
import QCXSelectGrupoDespesaAutocomplete from '../../shared-components/final-select-grupo-despesa/QCXSelectGrupoDespesaAutocomplete';
import QCXSelectTransportadorInternacionalAutocomplete from '../../shared-components/select-transportador-internacional/QCXSelectTransportadorInternacionalAutocomplete';
import QCXSelectTarifaAutocomplete from '../../shared-components/final-select-tarifa-field/QCXSelectTarifaAutocomplete';
import { getLabelAeroportoDesembarque, getLabelAeroportoEmbarque, getLabelAgenteCarga, getLabelCargaPerigosa, getLabelCiaAerea, getLabelCliente, getLabelConsignatario, getLabelDestino, getLabelIncoterm, getLabelNrVoo, getLabelNumeroProcesso, getLabelOrigem, getLabelServico, getLabelTabelaFrete, getLabelTarifa, getLabelTipoEmbarque, getTitleOfHouse } from '../../features/house/houseUtils';
import QCXAgenteCargaOrAmadorComponent from './components/QCXAgenteCargaOrAmadorComponent';
import QCXAeroportoOrPortoComponent from './components/QCXAeroportoOrPortoComponent';
import { houseVolumesSelectors, houseVolumesSliceActions } from '../../features/house-volume/houseVolumeSlices';
import { houseReferenciasSelectors, houseReferenciasSliceActions } from '../../features/house-referencias/houseReferenciasSlices';
import QCXSelectEmpresaEstrangeiraAutocompleteAutoLoad from '../../shared-components/final-select-empresa-estrangeira-field/QCXSelectEmpresaEstrangeiraAutocompleteAutoLoad';
import QCXFinalSelectGenericoAutocomplete from '../../shared-components/select-tipo-frete/QCXFinalSelectGenericoAutocomplete';
import QCXFinalSelectNotifyAutocomplete from '../../shared-components/select-notify/QCXFinalSelectNotifyAutocomplete';
import QCXSelectMoedaAutocomplete from '../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';

const useStyles = makeStyles(() => ({
    gridFields: {
        paddingBottom: '16px',
    },
}));

export default function QCXHouseForm({
    initialValues,
    handleSubmit,
    isConsult,
    isUpdate,
    controlComponentProps,
    authInfo = {},
    tipoEmbarque,
    setTipoEmbarque,
    cargaPerigosa,
    setCargaPerigosa,
    type,
    requiredRoles = [],
}) {

    const { t } = useTranslation();

    const classes = useStyles();

    const isHAWB = type === 'HAWB';
    const isHBL = type === 'HBL';

    const handleTipoEmbarqueChange = (event) => {
        setTipoEmbarque(event.target.value)
    };

    const handleCargaPerigosaChange = (event) => {
        setCargaPerigosa(event.target.value)
    };

    const reducerConfig = useMemo(() => ({
        selectors: {
            selectStatus: houseReferenciasSelectors.selectStatus,
            selectMode: houseReferenciasSelectors.selectMode,
            selectModel: houseReferenciasSelectors.selectModel,
        },
        actions: {
            loading: houseReferenciasSliceActions.loading,
            resetStatus: houseReferenciasSliceActions.resetStatus,
            changeToUpdateMode: houseReferenciasSliceActions.changeToUpdateMode,
            changeToCreateMode: houseReferenciasSliceActions.changeToCreateMode,
            resetMode: houseReferenciasSliceActions.resetMode,
            setModel: houseReferenciasSliceActions.setModel,
            resetModel: houseReferenciasSliceActions.resetModel,
        },
    }), []);

    const listProps = useMemo(
        () => ({
            name: 'referencias',
            columns: [
                {
                    field: 'referencia',
                    headerName: t('com.muralis.qcx.referencia'),
                    headerAlign: 'left',
                    align: 'left',
                    flex: 140,
                    valueGetter: ({ row }) => row?.referencia || '',
                },
            ],
        }),
        []
    );

    const formProps = useMemo(
        () => ({
            rootName: 'ignorableFields.referenciaCliente',
            fields: [
                {
                    name: 'referencia',
                    label: t('com.muralis.qcx.referenciaCliente'),
                },
            ],
        }),
        []
    );

    const handleAdd = useCallback(async (currentVinculo, currentVinculos, handleSuccessAddVinculo) => {
        const vinculo = {
            id: uuid(),
            referencia: currentVinculo?.referencia,
        };

        const updatedVinculos = [...currentVinculos, vinculo];

        handleSuccessAddVinculo(updatedVinculos);
    }, []);

    const handleUpdate = useCallback(async (currentVinculo, currentVinculos, handleSuccessUpdateVinculo) => {
        const updatedVinculo = {
            ...currentVinculo,
            referencia: currentVinculo?.referencia,
        };

        const updatedVinculos =
            currentVinculos?.map((existingVinculo) =>
                isStrictEquals(existingVinculo?.id, updatedVinculo?.id) ? updatedVinculo : existingVinculo
            ) || currentVinculos;

        handleSuccessUpdateVinculo(updatedVinculos);
    }, []);

    const handleAlreadyExists = useCallback((currentVinculo, currentVinculosList) =>
        currentVinculosList.some(
            (vinculo) =>
                isStrictEquals(vinculo?.referencia, currentVinculo?.referencia) &&
                !isStrictEquals(vinculo?.id, currentVinculo?.id)
        ), []);

    return (
        <QCXFormStepWizard
            initialValues={initialValues}
            onSubmit={handleSubmit}
            controlComponentProps={controlComponentProps}
            onChangeListeners={undefined}
            authInfo={authInfo}
            requiredRoles={requiredRoles}
        >
            {({ values }) => (
                <>
                    <NotifyAgenteCargaSync />
                    <NotifyClienteSync isConsult={isConsult} />
                    <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12}>
                        <Grid item xs={12} sm={4} md={4} lg={4} >
                            <QCXFinalTextField
                                id="text-field-code"
                                key="text-field-code"
                                name="numeroProcesso"
                                label={getLabelNumeroProcesso(type)}
                                disabled
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <QCXSelectClienteAutocomplete
                                id="autocomplete-select-importador-field"
                                key="autocomplete-select-importador-field"
                                name="cliente.id"
                                label={getLabelCliente(type)}
                                initialValues={values}
                                disabled
                                required
                            />
                        </Grid>

                        <ConsignatarioSection isConsult={isConsult} t={t} />

                    </Grid>
                    <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12}>
                        <Grid item xs={12} sm={6} md={6} >
                            <QCXSelectEmpresaEstrangeiraAutocompleteAutoLoad
                                id="autocomplete-select-exportador-field"
                                key="autocomplete-select-exportador-field"
                                name="exportador.id"
                                label="Exportador"
                                initialValues={values}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} md={2} >
                            <QCXFinalSelectGenericoAutocomplete
                                id="autocomplete-select-tipo-notify-field"
                                key="autocomplete-select-tipo-notify-field"
                                name="tipoNotify"
                                label="Tipo Notify"
                                optionsProp={[
                                    { label: 'Cliente', value: 'CLIENTE' },
                                    { label: 'Agente', value: 'AGENTE' },
                                    { label: 'Despachante', value: 'DESPACHANTE' },
                                ]}
                                initialValues={values}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} >
                            <QCXFinalSelectNotifyAutocomplete
                                id="autocomplete-select-notify-field"
                                key="autocomplete-select-notify-field"
                                name="notifyId"
                                tipoNotifyField="tipoNotify"
                                label="Notify"
                                initialValues={values}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <QCXSelectServicoAutocomplete
                                id="text-servico-field-code"
                                key="text-servico-field-code"
                                name="servico.id"
                                label={getLabelServico(type)}
                                disabled
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} md={2}>
                            <QCXFinalSelectGenericoAutocomplete
                                id="text-tarifa-field-code"
                                key="text-tarifa-field-code"
                                name="tarifa"
                                label="Tarifa"
                                optionsProp={[
                                    { label: 'Tarifário', value: 'TARIFARIO' },
                                    { label: 'Spot', value: 'SPOT' },
                                ]}
                                initialValues={values}
                                disabled={isConsult}
                                required
                            />
                        </Grid>

                        <TarifaCamposSync isConsult={isConsult} />

                        {values?.tarifa === 'TARIFARIO' ? (
                            <Grid item xs={12} sm={4} md={4} lg={4}>
                                <QCXSelectTabelaFreteAutocomplete
                                    id="autocomplete-select-field-grupo-despesa"
                                    key="autocomplete-select-field-grupo-despesa"
                                    name="tabelaFrete.id"
                                    label={getLabelTabelaFrete(type)}
                                    disabled={isConsult}
                                    initialValues={values}
                                    required={!isConsult}  
                                />
                            </Grid>
                        ) : null}

                        {values?.tarifa === 'SPOT' ? (
                            <>
                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                    <QCXSelectMoedaAutocomplete
                                        id="select-field-moeda-tarifa-spot"
                                        key="select-field-moeda-tarifa-spot"
                                        name="moeda.id"
                                        label="Moeda"
                                        disabled={isConsult}
                                        initialValues={values}
                                        required={!isConsult}  
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2} md={2} lg={2}>
                                    <QCXFinalAlternativeCurrencyField
                                        id="field-tarifa-spot"
                                        key="field-tarifa-spot"
                                        name="tarifaSpot"
                                        label="Tarifa Spot"
                                        disabled={isConsult}
                                        scale={5}
                                        required={!isConsult}  
                                    />
                                </Grid>
                            </>
                        ) : null}
                    </Grid>
                    <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12}>
                        <Grid item xs={12} sm={1} md={1} lg={1}>
                            <QCXSelectPortoAeroportoLocalOrigemAutocomplete
                                id="autocomplete-select-origem-field"
                                key="autocomplete-select-origem-field"
                                name="origem.id"
                                label={getLabelOrigem(type)}
                                initialValues={values}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={1} md={1} lg={1}>
                            <QCXSelectPortoAeroportoLocalDestinoAutocomplete
                                id="autocomplete-select-destino-field"
                                key="autocomplete-select-destino-field"
                                name="destino.id"
                                label={getLabelDestino(type)}
                                initialValues={values}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} md={2}>
                            <QCXFinalSelectGenericoAutocomplete
                                id="autocomplete-select-destino-field"
                                key="autocomplete-select-destino-field"
                                name="tipoEmbarque"
                                label="Tipo Embarque"
                                optionsProp={[{ label: 'Back to Back', value: 'BACK_TO_BACK' },
                                { label: 'Consolidado', value: 'CONSOLIDADO' }]}
                                initialValues={values}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} md={2}>
                            <QCXFinalSelectGenericoAutocomplete
                                id="autocomplete-select-carga-perigosa-field"
                                key="autocomplete-select-carga-perigosa-field"
                                name="cargaPerigosa"
                                label="Carga Perigosa"
                                optionsProp={[{ label: 'Sim', value: 'SIM' },
                                { label: 'Não', value: 'NAO' }]}
                                initialValues={values}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <QCXSelectIncotermCondicaoVendaAutocomplete
                                id="select-field-incoterm"
                                key="select-field-incoterm"
                                name="incotermVenda.id"
                                label={getLabelIncoterm(type)}
                                initialValues={undefined}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <QCXAgenteCargaOrAmadorComponent
                                id="agente-carga-field"
                                key="agente-carga-field"
                                name="agenteCarga"               // <-- aqui
                                label={getLabelAgenteCarga(type)}
                                initialValues={values}
                                disabled={isConsult}
                                type={type}
                                agenteTransportador              // <-- adiciona essa prop (ver abaixo)
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <QCXAeroportoOrPortoComponent
                                id="text-field-code"
                                key="text-field-code"
                                name="aeroportoDesembarque.id"
                                label={getLabelAeroportoDesembarque(type)}
                                disabled={isConsult}
                                type={type}
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} style={{ 'marginTop': '20px' }} xs={12} sm={12} md={12}>

                        <Grid item xs={12} sm={4} md={4} lg={4}>
                            <QCXSelectTransportadorInternacionalAutocomplete
                                id="autocomplete-select-origem-field"
                                key="autocomplete-select-origem-field"
                                name="transportadorInternacional"
                                label={getLabelCiaAerea(type)}
                                initialValues={values}
                                maritimoOnly={isHBL}
                                aereoOnly={isHAWB}
                                disabled={isConsult}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={2} md={2} lg={2}>
                            <QCXFinalTextField
                                id="text-field-code"
                                key="text-field-code"
                                name="numeroVooViagem"
                                label={getLabelNrVoo(type)}
                                disabled={isConsult}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <QCXSelectPortoAeroportoLocalAeroportoAutocomplete
                                id="text-field-code"
                                key="text-field-code"
                                name="aeroportoEmbarque.id"
                                label={getLabelAeroportoEmbarque(type)}
                                disabled={isConsult}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '20px' }}>
                        <QCXFormSubtitle title={t('com.muralis.qcx.referenciasCliente')} />
                    </Grid>
                    <Grid container xs={12} style={{ marginTop: '20px' }}>
                        <QCXFinalBondManagerOld
                            isParentConsult={isConsult}
                            reducerConfig={reducerConfig}
                            listProps={listProps}
                            formProps={formProps}
                            controlButtonsGridProps={{
                                add: {
                                    xs: 12,
                                    sm: 4,
                                    md: 4,
                                },
                                update: {
                                    xs: 6,
                                    sm: 2,
                                    md: 2,
                                },
                                clear: {
                                    xs: 6,
                                    sm: 2,
                                    md: 2,
                                },
                            }}
                            handleAdd={handleAdd}
                            handleUpdate={handleUpdate}
                            handleAlreadyExists={handleAlreadyExists}
                        >
                            {({ loading }) => (
                                <Grid item className={classes.customGridFields} xs={12} sm={8} md={8}>
                                    <QCXFinalTextField
                                        id="text-field-vinculo-referencia-cliente"
                                        key="text-field-vinculo-referencia-cliente"
                                        name="ignorableFields.referenciaCliente.referencia"
                                        label={t('com.muralis.qcx.referenciaCliente')}
                                        maxLength={100}
                                        disabled={isConsult || loading}
                                    />
                                </Grid>
                            )}
                        </QCXFinalBondManagerOld>
                    </Grid>
                </>
            )}
        </QCXFormStepWizard>
    )
}

function ConsignatarioSection({ isConsult, t }) {
    const form = useForm();
    const { values } = useFormState();

    const consignatarioIgualCliente = values?.consignatarioIgualCliente !== false; // default true
    const clienteId = values?.cliente?.id;

    useEffect(() => {
        if (values?.consignatarioIgualCliente === undefined) {
            form.change('consignatarioIgualCliente', true);
        }
    }, []);

    useEffect(() => {
        if (consignatarioIgualCliente) {
            if (clienteId) {
                form.change('consignatario.id', clienteId);
            } else {
                form.change('consignatario.id', null);
            }
        }
    }, [consignatarioIgualCliente, clienteId]);

    const handleToggle = (event) => {
        const { checked } = event.target;
        form.change('consignatarioIgualCliente', checked);

        if (!checked) {
            form.change('consignatario.id', null);
        } else {
            form.change('consignatario.id', clienteId || null);
        }
    };

    return (
        <>
            <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={consignatarioIgualCliente}
                            onChange={handleToggle}
                            color="primary"
                            disabled={isConsult}
                        />
                    }
                    label="Consignatário igual ao Cliente"
                />
            </Grid>

            {!consignatarioIgualCliente ? (
                <Grid item xs={12} sm={6} md={6} lg={6}>
                    <QCXSelectClienteAutocomplete
                        id="autocomplete-select-consignatario-field"
                        key="autocomplete-select-consignatario-field"
                        name="consignatario.id"
                        label={t('com.muralis.qcx.aereo.table.consignatario') /* ou getLabelConsignatario(type) */}
                        initialValues={values}
                        disabled={isConsult}
                        required
                    />
                </Grid>
            ) : null}
        </>
    );
}

export { ConsignatarioSection };

function NotifyAgenteCargaSync() {
    const form = useForm();
    const { values } = useFormState();

    const tipoNotify = values?.tipoNotify;
    const notifyId = values?.notifyId;

    const agenteCargaIdAtual = values?.agenteCarga?.id;

    const lastNotifyIdRef = useRef(null);

    useEffect(() => {
        if (tipoNotify !== 'AGENTE') {
            lastNotifyIdRef.current = null;
            return;
        }

        if (!notifyId) return;

        const lastNotify = lastNotifyIdRef.current;

        const podeSobrescrever =
            !agenteCargaIdAtual || (lastNotify && agenteCargaIdAtual === lastNotify);

        if (podeSobrescrever) {
            form.change('agenteCarga', notifyId ? { id: notifyId } : null);
            lastNotifyIdRef.current = notifyId;
        }
    }, [tipoNotify, notifyId, agenteCargaIdAtual, form]);

    return null;
}

export { NotifyAgenteCargaSync };

function TarifaCamposSync({ isConsult }) {
    const form = useForm();
    const { values } = useFormState();

    const tarifa = values?.tarifa;

    useEffect(() => {
        if (isConsult) return;

        if (tarifa === 'SPOT') {
            form.change('tabelaFrete.id', null);
        }

        if (tarifa === 'TARIFARIO') {
            form.change('moeda.id', null);
            form.change('tarifaSpot', null);
        }

    }, [tarifa, isConsult]);

    return null;
}

export { TarifaCamposSync };

function NotifyClienteSync({ isConsult }) {
  const form = useForm();
  const { values } = useFormState();

  const tipoNotify = values?.tipoNotify;
  const notifyIdAtual = values?.notifyId;
  const clienteId = values?.cliente?.id;

  const lastClienteIdRef = useRef(null);

  useEffect(() => {
    if (isConsult) return;

    if (tipoNotify !== 'CLIENTE') {
      lastClienteIdRef.current = null;
      return;
    }

    if (!clienteId) return;

    const lastCliente = lastClienteIdRef.current;

    const podeSobrescrever =
      !notifyIdAtual || (lastCliente && notifyIdAtual === lastCliente);

    if (podeSobrescrever) {
      form.change('notifyId', clienteId);
      lastClienteIdRef.current = clienteId;
    }
  }, [tipoNotify, clienteId, notifyIdAtual, isConsult, form]);

  return null;
}

export { NotifyClienteSync };


